import styled from "styled-components";

export const H1Heading = styled.h1`
  padding: 0 auto;
  margin: 0 auto;
  font-size: 50px;
  color: yellow;
  font-family: "Bungee", cursive;
`;

export const H3Heading = styled.h3`
  padding: 0 auto;
  margin: 0 auto;
  font-size: 1.5rem;
  color: red;
`;

export const H5Heading = styled.h5`
  text-align: center;
  line-height: 1.5rem;
  margin: 10px auto;
  color: #fff;
`;
